import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client';
export const FLOW_REFERENCES_FIELDNAME = 'automation_ui_management_flowReferences';
/**
 * @deprecated in favor of migration to automationmanagement/v1/references
 * DO NOT USE DIRECTLY. Instead, use the hook useFlowReferences:
 * https://git.hubteam.com/HubSpot/automation-ui-management/blob/8d4a631be8f611e24e987f364237b5014a560d47/automation-ui-management/static-1.60113/js/hooks/flowReferencesHook.ts#L11
 */
export const GET_FLOW_REFERENCES_DEPRECATED = registerQuery({
  fieldName: FLOW_REFERENCES_FIELDNAME,
  args: ['flowId', 'flowSource', 'includeInboundReferences', 'includeOutboundReferences'],
  fetcher({
    flowId,
    flowSource,
    includeInboundReferences,
    includeOutboundReferences = false
  }) {
    return http.post('automationplatform/v1/hybrid/references', {
      data: {
        flows: [{
          flowId,
          flowSource
        }],
        includeInboundReferences,
        includeOutboundReferences
      }
    }).then(response => {
      if (response.flowReferences.length) {
        return response.flowReferences[0];
      }
      return undefined;
    });
  }
});

/**
 * DO NOT USE DIRECTLY. Instead, use the hook useFlowReferences:
 * https://git.hubteam.com/HubSpot/automation-ui-management/blob/8d4a631be8f611e24e987f364237b5014a560d47/automation-ui-management/static-1.60113/js/hooks/flowReferencesHook.ts#L11
 */
export const GET_FLOW_REFERENCES = registerQuery({
  fieldName: FLOW_REFERENCES_FIELDNAME,
  args: ['flowId', 'includeInboundReferences', 'includeOutboundReferences'],
  fetcher({
    flowId,
    includeInboundReferences,
    includeOutboundReferences = false
  }) {
    return http.post('automationmanagement/v1/references', {
      data: {
        flowIds: [flowId],
        includeInboundReferences,
        includeOutboundReferences
      }
    }).then(response => {
      if (response.flowReferences.length) {
        return response.flowReferences[0];
      }
      return undefined;
    });
  }
});